import { render } from "./no-search-results-spellcheck-component.vue?vue&type=template&id=58b1066f"
import script from "./no-search-results-spellcheck-component.vue?vue&type=script&lang=js"
export * from "./no-search-results-spellcheck-component.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__